import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useLang } from "../LangContext";
import { CONTACT } from "../constants";

const Item = ({ icon: Icon, label, value, href, testId }) => {
  const content = (
    <div className="flex items-start gap-4">
      <div className="h-12 w-12 rounded-full bg-[#7a8b50]/15 flex items-center justify-center shrink-0">
        <Icon className="h-5 w-5 text-[#7a8b50]" />
      </div>
      <div>
        <div className="text-[11px] uppercase tracking-[0.22em] text-[#7a8b50] font-semibold mb-1">{label}</div>
        <div className="text-base text-[#1e3a5f] font-medium">{value}</div>
      </div>
    </div>
  );
  if (href) {
    return (
      <a href={href} data-testid={testId} className="block hover:opacity-80 transition-opacity">
        {content}
      </a>
    );
  }
  return <div data-testid={testId}>{content}</div>;
};

export default function ContactSection() {
  const { t } = useLang();
  return (
    <section
      id="contacto"
      className="py-24 md:py-32 bg-[#FAFAF5]"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#7a8b50]" />
              <span className="text-[11px] uppercase tracking-[0.28em] text-[#7a8b50] font-semibold">
                {t.smallLabels.contact}
              </span>
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl text-[#1e3a5f] font-medium tracking-tight leading-tight">
              {t.contact.title}
            </h2>

            <div className="mt-10 grid grid-cols-1 gap-7">
              <Item
                testId="contact-phone"
                icon={Phone}
                label={t.contact.phone}
                value={CONTACT.phoneDisplay}
                href={`tel:${CONTACT.phoneIntl}`}
              />
              <Item
                testId="contact-email"
                icon={Mail}
                label={t.contact.email}
                value={CONTACT.email}
                href={`mailto:${CONTACT.email}`}
              />
              <Item
                testId="contact-address"
                icon={MapPin}
                label={t.contact.address}
                value={t.contact.addressValue}
              />
              <Item
                testId="contact-hours"
                icon={Clock}
                label={t.contact.hours}
                value={t.contact.hoursValue}
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative h-[480px] lg:h-full min-h-[420px] rounded-3xl overflow-hidden border border-[#7a8b50]/20 shadow-sm">
              <iframe
                title="Munguía, Bizkaia"
                data-testid="contact-map"
                src="https://www.google.com/maps?q=Munguia,+Bizkaia,+Spain&hl=es&z=14&output=embed"
                className="absolute inset-0 w-full h-full"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
